import React from "react";
import DataTable from "react-data-table-component";
import { useIntl } from "react-intl";
import { RiErrorWarningLine } from "react-icons/ri";
import ModernLoader from "../ModernLoader";

import {
  TableContainer,
  TableTitle,
  TableTitleContainer,
  NoDataText,
  NoDataStaff,
  NoDataTitle,
} from "./styles";

const Table = ({
  title,
  columns,
  data,
  hasPagination = true,
  className,
  striped = false,
  titleMarginLeft,
  paddingAround,
  staffCategory,
  onSorted,
  selectableRows = false, // ← habilita seleção de linhas
  onSelectedRowsChange, // ← callback opcional
  selectableRowDisabled, // ← caso queira desabilitar algumas linhas
  selectableRowSelected, // ← caso queira controlar seleção manualmente
  clearSelectedRows = false, // ← nova prop para forçar limpeza da seleção
  expandableRowsComponent = null, // ← componente para linhas expansíveis
  onRowExpandToggled,
  expandableRowDisabled,
  ...rest
}) => {
  const intl = useIntl();

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "rgba(218, 218, 218, 0.25)",
      },
    },
    headCells: {
      style: {
        color: "#000",
        fontSize: "14px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        textAlign: "left",
      },
    },
    rows: {
      style: {
        backgroundColor: "#fff",
        borderLeft: "4px solid #fff",
        "&:hover": {
          borderLeft: "4px solid #002244",
          backgroundColor: "rgba(17, 167, 217, 0.05) !important",
        },
      },
    },
  };

  return (
    <TableContainer className={className} paddingAround={paddingAround}>
      {title && (
        <TableTitleContainer titleMarginLeft={titleMarginLeft}>
          <TableTitle>{title}</TableTitle>
        </TableTitleContainer>
      )}

      <DataTable
        expandableRows={!!expandableRowsComponent}
        expandableRowsComponent={expandableRowsComponent}
        expandOnRowClicked
        onRowExpandToggled={onRowExpandToggled}
        expandableRowDisabled={expandableRowDisabled}
        columns={columns}
        data={data}
        responsive
        sortServer={onSorted}
        onSort={onSorted}
        customStyles={customStyles}
        selectableRows={selectableRows} // ← habilita seleção
        onSelectedRowsChange={onSelectedRowsChange} // ← callback ao selecionar
        selectableRowDisabled={selectableRowDisabled} // ← opcional
        selectableRowSelected={selectableRowSelected} // ← opcional
        clearSelectedRows={clearSelectedRows} // ← força limpeza da seleção
        noDataComponent={
          staffCategory ? (
            <NoDataStaff>
              <RiErrorWarningLine style={{ fontSize: "72px" }} />

              <NoDataTitle>
                {intl.formatMessage({
                  id: "nothing_here_yet",
                })}
              </NoDataTitle>
              <span>
                {intl.formatMessage({
                  id: "click_new_to_start",
                })}
              </span>
            </NoDataStaff>
          ) : (
            <NoDataText>
              {intl.formatMessage({
                id: "no_records_to_display",
              })}
            </NoDataText>
          )
        }
        pagination={hasPagination ? true : false}
        striped={striped}
        paginationComponentOptions={{
          rowsPerPageText: intl.formatMessage({ id: "rows_per_page" }),
          rangeSeparatorText: intl.formatMessage({ id: "of" }),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: intl.formatMessage({ id: "all" }),
        }}
        progressComponent={<ModernLoader size="medium" showText={true} />}
        {...rest}
      />
    </TableContainer>
  );
};

export default Table;
